module.exports = __webpack_public_path__ + "media/images/icons/outlined/user-add-d54e19b67cb05e2a4adb7f030ee47929.svg";